import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { DeclaracionesService } from "./declaraciones.service";
import { Declaracion, DireccionMercaderia, DeclaracionesEntity, DeclaracionUsuario, DireccionRubroIncendio, DetalleDeclaracion, Mercaderia } from "../entities/declaracion_entity";
import { correctHeight, detectBody } from "../../../app.helpers";
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { parse } from 'url';
import { CampoValor } from '../entities/datos_generales_entity';
import { PolizaEntity } from '../entities/polizas_cliente_entity';
import { UtilService } from '../../../components/common/utils/util.service';

const swal = require("sweetalert2");

declare var jQuery: any;

@Component({
    selector: 'declaraciones',
    templateUrl: 'declaraciones.template.html'
})

export class DeclaracionesComponent implements OnInit {
    declaraciones: DeclaracionesEntity[];
    showLoader: string;
    bandera: boolean;
    usuario: ClienteLogin;
    usuarioEmpresa: ClienteXCiudad;
    direcciones: DireccionMercaderia[];
    direccionMercaderia: number;
    banderaDireccion: boolean;
    declaracionesMensuales: Declaracion[];
    banderaDeclaraionMeses: boolean;
    banderaIncendioTransporte: boolean;
    totalValorDeclarado: number;
    totalValorReal: number;
    totalPrimaNeta: number;
    banderaInputValorDeclarado: boolean;
    banderaInputPrimaNeta: boolean;
    banderaInputValorReal: boolean;
    fechaDefault: Date;
    ramoPoliza: string;
    limite: number;
    tasa: number;
    declaraActual: DireccionMercaderia;
    promedioMensual: number;
    primaEnDeposito: number;
    primaAPagar: number;
    primaNetaAnualReal: number;
    nombreDireccionADeclarar: string;

    sinParametrizar: boolean;
    observaciones: string;
    direccionesRubro: DireccionRubroIncendio[];
    seleccionarMesInicio: boolean = false;
    mesInicioDeclaracion: number;
    listaMesesIni: CampoValor[] = new Array<CampoValor>();
    direccionRubro: number;
    polizaSeleccionada: DeclaracionesEntity;
    sinDeclaraciones: boolean = true;
    tablaDeclarativa: DetalleDeclaracion[];
    banderaSiguienteAnio: boolean = false;
    codigoCabDeclaracion: number = 0;
    totalDeclarado: number = 0;
    totalAjuste: number = 0;    
    limiteAsegurado: number;
    primaDeposito: string;
    modalidad: number;
    periodicidad: string;
    valuacion: string;
    //public mascaraNumeros = numberMask;
    totalAnualDeclarado: number = 0;
    primaApagar: number = 0;  
    dirRubro: DireccionRubroIncendio;
    chkSeleccionado: boolean = false;
    superaLimite: boolean = false;
    mercaderiasTransporte: Mercaderia[];
    mercaderia: Mercaderia;
    anual: number = 0;
    rubroVacio: DireccionRubroIncendio;
    mercaderiaVacia: Mercaderia;

    constructor(
        private declaracionesService: DeclaracionesService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        public utilsService: UtilService,
    ) { }

    ngOnInit() {
        this.ramoPoliza = "";
        this.limite = 0;
        this.totalValorDeclarado = 0;
        this.totalValorReal = 0;
        this.totalPrimaNeta = 0;
        this.direccionMercaderia = 0;
        this.banderaIncendioTransporte = false;
        this.banderaDireccion = false;
        this.banderaDeclaraionMeses = false;
        this.declaraciones = new Array<DeclaracionesEntity>();
        this.direcciones = new Array<DireccionMercaderia>();
        this.declaracionesMensuales = new Array<Declaracion>();
        this.showLoader = "sk-loading";
        this.bandera = false;
        this.tasa = 0;
        this.promedioMensual = 0;
        this.declaraActual = new DireccionMercaderia();
        this.primaAPagar = 0;
        this.primaEnDeposito = 0;
        this.primaNetaAnualReal = 0;
        
        this.sinParametrizar = false;
        this.observaciones = "";
        this.direccionesRubro = new Array<DireccionRubroIncendio>();
        this.direccionRubro = 0; 
        this.polizaSeleccionada = new DeclaracionesEntity();
        this.dirRubro = new DireccionRubroIncendio();        
        this.superaLimite = false;
        this.mercaderiasTransporte = new Array<Mercaderia>();   
        this.anual = 0;     
        this.mercaderia = new Mercaderia();
        this.rubroVacio = new DireccionRubroIncendio();
        this.rubroVacio.CodigoBien = 0;
        this.mercaderiaVacia = new Mercaderia();
        this.mercaderiaVacia.CodigoMercaderia = 0;

        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                try {
                    this.usuarioEmpresa = JSON.parse(this.sesionStorageService.retrieve("usuarioEmpresa"));
                } catch (error) {
                    this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                }

                this.cargaTodo();
                this.sesionStorageService.observe("usuarioEmpresa").subscribe(v => {
                    try {
                        this.usuarioEmpresa = JSON.parse(v);
                        this.cargaTodo();
                    } catch (e) {
                        this.usuarioEmpresa = v;
                        this.cargaTodo();
                    }
                });
            }
        }
        this.showLoader = "";
    }

    cargaTodo() {
        this.declaracionesService.ConsultarPolizasDeclarativas(this.usuarioEmpresa).subscribe(result => {
            this.declaraciones = result;

        }, error => { this.handleError.redirectUrl(error); })
    }

    Declarar(polizaDeclarativa: DeclaracionesEntity) { 

        this.polizaSeleccionada = new DeclaracionesEntity();
        this.polizaSeleccionada = polizaDeclarativa;
        this.tablaDeclarativa = new Array<DetalleDeclaracion>();
        this.periodicidad = "";
        this.valuacion = "";
        this.primaDeposito = "";
        this.modalidad = 0;
        this.limiteAsegurado = 0;
        this.tasa = 0;
        this.seleccionarMesInicio = false;

        if (polizaDeclarativa.CodigoRamo.toString() === "0300") {
            this.banderaIncendioTransporte = true;

            this.declaracionesService.CargarDireccionesDeclarativas(polizaDeclarativa).subscribe(
                result => {
                    this.direccionesRubro = result;
                    if(this.direccionesRubro == undefined || this.direccionesRubro == null || this.direccionesRubro.length == 0)
                        this.sinParametrizar = true;
                    else
                        this.dirRubro = this.rubroVacio;
                }
            );

        } else {
            this.banderaIncendioTransporte = false; 

            this.declaracionesService.CargarMercaderiasDeclarativas(polizaDeclarativa).subscribe(
                result => {
                    this.mercaderiasTransporte = result;
                    if(this.mercaderiasTransporte == undefined || this.mercaderiasTransporte == null || this.mercaderiasTransporte.length == 0)
                        this.sinParametrizar = true;
                    else
                        this.mercaderia = this.mercaderiaVacia;
                }
            );

        }
        this.ramoPoliza = polizaDeclarativa.CodigoRamo;
        this.direcciones = polizaDeclarativa.DireccionesMercaderias;
        this.direccionMercaderia = 0;
        this.banderaDireccion = true;
        this.banderaDeclaraionMeses = false;
        this.limite = 0;
    }

    cloneMercaderia(c: DireccionMercaderia) {
        let mercaderia = new DireccionMercaderia();
        for (let prop in c) {
            mercaderia[prop] = c[prop];
        }
        return mercaderia;
    }

    CargarDeclaraciones() {

        this.seleccionarMesInicio = false;
        this.sinDeclaraciones = false;
        this.tablaDeclarativa = new Array<DetalleDeclaracion>();
        //this.EncerarAjuste();
    
        let polizaDecl = new PolizaEntity();
        polizaDecl.CodigoRamo = this.polizaSeleccionada.CodigoRamo;
        polizaDecl.CodigoRubro = this.polizaSeleccionada.CodigoRamo.toString() === "0300" ? this.dirRubro.CodigoBien : this.mercaderia.CodigoMercaderia; 
        polizaDecl.Respolcod = this.polizaSeleccionada.CodigoPoliza;
        polizaDecl.FecVigIni = this.polizaSeleccionada.FechaInicioVigencia;
        polizaDecl.FecVigFin = this.polizaSeleccionada.FechaFinVigencia;

        //polizaDecl.poliza = this.poliza.Poliza;
    
        this.declaracionesService.CargarDeclaraciones(polizaDecl).subscribe(
          declaraciones => {
    
            if (declaraciones.CodigoCabDeclaracion != 0) { //existen declaraciones
    
              //this.tablaDeclarativa = new Array<DetalleDeclaracion>();
              this.codigoCabDeclaracion = declaraciones.CodigoCabDeclaracion;
              this.sinDeclaraciones = false;
              
              this.tablaDeclarativa = declaraciones.DetalleDeclaraciones;
    
              //this.VerificarExcesoLimite();
              //this.TotalizaValores();
            }
            else { //no existen declaraciones
    
              let diaInicio: number;
              this.sinDeclaraciones = true;
    
              diaInicio = Number(polizaDecl.FecVigIni.substr(0, 2));
    
              //si es pasado la mitad del mes se determina si se inician las declaraciones de los días del mismo mes o apartir del siguiente mes
              if (diaInicio > 15) {
    
                let mesInicioDeclaracionSiguiente: number;
                this.seleccionarMesInicio = true;
    
                this.mesInicioDeclaracion = Number(polizaDecl.FecVigIni.substr(3, 2));
    
                if (this.mesInicioDeclaracion == 12)
                  mesInicioDeclaracionSiguiente = 1
                else
                  mesInicioDeclaracionSiguiente = this.mesInicioDeclaracion + 1
    
    
                this.listaMesesIni = new Array<CampoValor>();
    
                this.listaMesesIni = [{ Campo: this.utilsService.TraerNombreMes(this.mesInicioDeclaracion), Valor: this.mesInicioDeclaracion },
                { Campo: this.utilsService.TraerNombreMes(mesInicioDeclaracionSiguiente), Valor: mesInicioDeclaracionSiguiente }];
    
                this.totalAjuste = 0;
                this.totalDeclarado = 0;
              }
    
            }
    
          },
          error => {
            console.log(error);
          }
        );
    
      }

    ConsultarParametrosIncendio() {

        if (this.dirRubro.CodigoBien > 0) {
            let rubro: DireccionRubroIncendio = this.direccionesRubro.filter(r => r.CodigoBien == this.dirRubro.CodigoBien)[0];

            this.periodicidad = rubro.Periodicidad.Campo;
            this.valuacion = rubro.Valuacion.Campo;
            this.primaDeposito = this.polizaSeleccionada.PrimaEnDeposito ? "Si" : "No";
            this.modalidad = this.polizaSeleccionada.Modalidad;
            this.limiteAsegurado = rubro.LimiteAsegurado;
            this.tasa = rubro.Tasa;

            this.CargarDeclaraciones();
        }
        else {
            this.LimpiarParametros();
        }

    }

    LimpiarParametros() {
        this.periodicidad = "";
        this.valuacion = "";
        this.primaDeposito = "";
        this.modalidad = 0;
        this.limiteAsegurado = 0;
        this.tasa = 0;
        this.anual = 0;
        this.seleccionarMesInicio = false;
        this.tablaDeclarativa = new Array<DetalleDeclaracion>();
    }

    ConsultarParametrosTransporte() {
        
        if (this.mercaderia.CodigoMercaderia > 0) {
            let rubro: Mercaderia = this.mercaderiasTransporte.filter(r => r.CodigoMercaderia == this.mercaderia.CodigoMercaderia)[0];

            this.periodicidad = rubro.Periodicidad.Campo;
            this.valuacion = rubro.Valuacion.Campo;
            this.primaDeposito = this.polizaSeleccionada.PrimaEnDeposito ? "Si" : "No";
            this.modalidad = this.polizaSeleccionada.Modalidad;
            this.limiteAsegurado = rubro.ValorAsegurado;
            this.anual = rubro.EstimadoMovilizacion;
            this.tasa = rubro.Tasa;

            this.CargarDeclaraciones();
        }
        else {
            this.LimpiarParametros();
        }
    }

      CrearTablaDeclaraciones() {

        let numeroPeriodo: number, mesSuma: number, mesTabla: number, anioDeclaracion: number, mesHasta: number;
        let anio: any, anioAux: any;
        let anioTabla: string;
        let fechaAux = new Date();
    
        let codigoPeriodicidad = this.polizaSeleccionada.Periodicidad.Valor;
    
    
        if (codigoPeriodicidad == 1) {
          numeroPeriodo = 12;
          mesSuma = 1;
        }
        else if (codigoPeriodicidad == 2) {
          numeroPeriodo = 6;
          mesSuma = 2;
          mesHasta = 1
        }
        else if (codigoPeriodicidad == 3) {
          numeroPeriodo = 4;
          mesSuma = 3;
          mesHasta = 2
        }
    
    
        this.tablaDeclarativa = new Array<DetalleDeclaracion>();
    
    
        //fecha vigencia con índice 0 (tiene 1 día menos)
        let fechaInicio = new Date(this.polizaSeleccionada.FechaInicioVigencia.substr(6, 4) + "-" +
          this.polizaSeleccionada.FechaInicioVigencia.substr(3, 2) + "-" +
          this.polizaSeleccionada.FechaInicioVigencia.substr(0, 2));
    
        //fecha correcta (sin indice 0)
        fechaInicio.setDate(fechaInicio.getDate() + 1);
    
        //corrección para cuando se suma un mes en fechas que al siguiente mes no tienen el día 29|30|31
        fechaInicio = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1);
        
        //cuando el día de mes de inicio de vigencia es <= 15
        if (this.mesInicioDeclaracion == undefined || this.mesInicioDeclaracion == null)
          this.mesInicioDeclaracion = Number(fechaInicio.getMonth() + 1);
    
        //si seleccionó el mes siguiente al vencimiento
        if (this.mesInicioDeclaracion != Number(fechaInicio.getMonth() + 1))
          fechaInicio.setMonth(fechaInicio.getMonth() + 1);
    
    
        mesTabla = fechaInicio.getMonth() + 1;
        anioTabla = fechaInicio.getFullYear().toString();
        anioDeclaracion = fechaInicio.getFullYear();
    
        fechaAux = fechaInicio;
        anio = anioTabla;
    
    
        //fecha actual
        let fechaActual: Date = new Date();
        let fechaMesActual: Date = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    
    
        //agrega filas según la periodicidad
        for (let index = 1; index <= numeroPeriodo; index++) {
    
          let detalle = new DetalleDeclaracion();
    
          //mensual
          if (codigoPeriodicidad == 1) {
    
            detalle.Mes = this.utilsService.TraerNombreMes(mesTabla);
            detalle.Anio = anioTabla;
            detalle.FechaMesAnio = new Date(anioDeclaracion, mesTabla - 1, 1);
            detalle.ValorAjuste = 0;
            detalle.ValorDeclarado = 0;
            detalle.PrimaNeta = 0;
    
    
            if (detalle.FechaMesAnio > fechaMesActual)
              detalle.Habilitado = false;
            else
              detalle.Habilitado = true;
    
    
            //fecha o período siguiente
            fechaAux.setMonth(fechaAux.getMonth() + mesSuma);
    
            mesTabla = fechaAux.getMonth() + 1;
            anioAux = fechaAux.getFullYear();
            anioDeclaracion = fechaAux.getFullYear();
    
            //muestra año en tabla
            if (anio != anioAux) {
              anioTabla = anioAux.toString();
              anio = anioAux;
            }
            else {
              anioTabla = "";
            }
    
          }
          else if (codigoPeriodicidad == 2 || codigoPeriodicidad == 3) { //bimestral o trimestral
    
            let mesIni: string, mesFin: string;
            let mesAux: number, anioIni: number, anioFin: number;
    
            //mes inicio período
            mesIni = this.utilsService.TraerNombreMes(mesTabla);
            anioIni = fechaAux.getFullYear();
    
            //mes fin período
            fechaAux.setMonth(fechaAux.getMonth() + mesHasta);
            mesAux = fechaAux.getMonth() + 1;
            mesFin = this.utilsService.TraerNombreMes(mesAux);
            anioFin = fechaAux.getFullYear();
    
            //verifica cambio de año entre períodos
            if (anioIni == anioFin)
              anioAux = anioFin;
            else
              anioAux = anioIni.toString() + " - " + anioFin.toString();
    
            //muestra año en tabla
            if (index == 1) {
              anioTabla = anioAux.toString();
              anio = anioAux;
            }
            else if (anio != anioAux) {
              anioTabla = anioAux.toString();
              anio = anioAux;
            }
            else {
              anioTabla = "";
            }
    
            detalle.Mes = mesIni + " - " + mesFin;
            detalle.Anio = anioTabla;
            detalle.FechaMesAnio = new Date(anioIni, mesTabla - 1, 1);
            detalle.ValorAjuste = 0;
            detalle.ValorDeclarado = 0;
            detalle.Periodo = index;
            detalle.PrimaNeta = 0;
    
            let fechaSiguiente = new Date(fechaAux.getFullYear(), fechaAux.getMonth(), 1);
    
            if (fechaSiguiente > fechaMesActual)
              detalle.Habilitado = false;
            else
              detalle.Habilitado = true;
    
            //fecha o período siguiente
            fechaAux.setMonth(fechaAux.getMonth() + 1);
    
            mesTabla = fechaAux.getMonth() + 1;
            anioAux = fechaAux.getFullYear();
            anioDeclaracion = fechaAux.getFullYear();
    
          }
    
          this.tablaDeclarativa.push(detalle);
          this.tablaDeclarativa = JSON.parse(JSON.stringify(this.tablaDeclarativa));
    
        }
    
        //this.TotalizaValores();
        //this.VerificarSeleccionados();
        this.sinDeclaraciones = false;
    
      }


      VerificarAjuste(codigoDetalle: number)
      {
          if(this.ramoPoliza == '0300')
          {
            this.VerificarAjusteIncendio(codigoDetalle);
          }
          else
          {
            this.VerificarAjusteTransporte(codigoDetalle);
          }
      }

      VerificarAjusteIncendio(codigoDetalle: number) {

        this.superaLimite = false;

        if (codigoDetalle == 0 || codigoDetalle == undefined) { //tabla sin grabar, aplica a todos los registros
    
          this.tablaDeclarativa.forEach(d => {
    
            if (d.Seleccionado && d.ValorDeclarado != null) {
              let valorDeclaradoAux = d.ValorDeclarado.toString().replace(/,/g, '');
              let valorDeclarado = Number(valorDeclaradoAux);
    
              if (valorDeclarado > this.limiteAsegurado)
              {
                d.ValorAjuste = this.limiteAsegurado;                
                this.superaLimite = true;
              }
              else
              {
                d.ValorAjuste = valorDeclarado;                
              }
            }
    
          });
    
        }
        else {
          let registroCambiado: DetalleDeclaracion = new DetalleDeclaracion();
    
          this.tablaDeclarativa.filter(d => d.CodigoDetDeclaracion == codigoDetalle).forEach(t => {
            registroCambiado = t;
          });
    
          if (registroCambiado.ValorDeclarado != undefined) {
            let valorDeclaradoAux = registroCambiado.ValorDeclarado.toString().replace(/,/g, '');
            let valorDeclarado = Number(valorDeclaradoAux);
    
            if (valorDeclarado > this.limiteAsegurado)
            {
              registroCambiado.ValorAjuste = this.limiteAsegurado;
              this.superaLimite = true;
            }
            else
              registroCambiado.ValorAjuste = valorDeclarado;
          }
    
          this.tablaDeclarativa.forEach(d => {
            if (d.CodigoDetDeclaracion == codigoDetalle)
              d.ValorAjuste = registroCambiado.ValorAjuste;
          });
        }
    
        this.TotalizaValores();
        //this.CalcularPrimas();
    
      }

      editarItemSeleccionado(detalle: DetalleDeclaracion) {

        if (detalle.Seleccionado) {
          detalle.ValorDeclarado = null;
          detalle.ValorAjuste = null;
          detalle.PrimaNeta = null;
        }
        else {
          detalle.ValorDeclarado = 0;
          detalle.ValorAjuste = 0;
          detalle.PrimaNeta = 0;
        }
    
        this.VerificarSeleccionados();
        this.VerificarAjuste(detalle.CodigoDetDeclaracion);
      }


      VerificarSeleccionados() {

        let seleccionado: boolean = false;
    
        if (this.tablaDeclarativa != null && this.tablaDeclarativa != undefined) {
          this.tablaDeclarativa.forEach(t => {
            if (t.Seleccionado) {
              seleccionado = true;
              return seleccionado;
            }
          });
        }    
        this.chkSeleccionado = seleccionado;    
      }

      TotalizaValores() {
          if(this.ramoPoliza == "0300")
            this.TotalizaValoresIncendio();
          else
            this.TotalizaValoresTransporte();
      }

      TotalizaValoresIncendio() {

        //this.priNet = 0;
        //this.priTot = 0;
        let valorAjusteAux: number = 0;
        let valorDeclaradoAux: number = 0;
        let mesesDeclarados: number = 0;
        this.EncerarAjuste();
    
        if (this.tablaDeclarativa != null && this.tablaDeclarativa != undefined) {
    
          this.tablaDeclarativa.forEach(d => {
    
            if (d.ValorDeclarado != null && d.Seleccionado) {
              let valorDeclarado = d.ValorDeclarado.toString().replace(/,/g, '');
              valorDeclaradoAux = valorDeclaradoAux + Number(valorDeclarado);
    
              let valorAjuste = d.ValorAjuste.toString().replace(/,/g, '');
              valorAjusteAux = valorAjusteAux + Number(valorAjuste);
    
              mesesDeclarados = mesesDeclarados + 1;
            }
    
          });
        }
    
        valorDeclaradoAux = Number(valorDeclaradoAux.toFixed(2));
        valorAjusteAux = Number(valorAjusteAux.toFixed(2));
    
        this.totalDeclarado = valorDeclaradoAux;
        this.totalAjuste = valorAjusteAux;
    
        //cálculo de ajustes
        this.totalAnualDeclarado = valorAjusteAux;
        this.promedioMensual = mesesDeclarados != 0 ? Number((valorAjusteAux / mesesDeclarados).toFixed(2)) : 0;
        this.primaNetaAnualReal = Number((this.promedioMensual * (this.tasa / 100)).toFixed(2));
        //this.primaEnDeposito = mesesDeclarados != 0 ? Number(((this.limiteAsegurado / mesesDeclarados) * (this.tasa / 100) * (this.modalidad / 100)).toFixed(2)) : 0;
        this.primaEnDeposito = mesesDeclarados != 0 ? Number(((this.limiteAsegurado) * (this.tasa / 100) * (this.modalidad / 100)).toFixed(2)) : 0;
        this.primaApagar = this.primaNetaAnualReal - this.primaEnDeposito;
      }      

      TotalizaValoresTransporte() {

        //this.priNet = 0;
        //this.priTot = 0;
        
        let valorPrimaNetaAux: number = 0;
        let valorDeclaradoAux: number = 0;
        let mesesDeclarados: number = 0;
        this.EncerarAjuste();
    
        if (this.tablaDeclarativa != null && this.tablaDeclarativa != undefined) {
    
          this.tablaDeclarativa.forEach(d => {
    
            if (d.ValorDeclarado != null && d.Seleccionado) {
              let valorDeclarado = d.ValorDeclarado.toString().replace(/,/g, '');
              valorDeclaradoAux = valorDeclaradoAux + Number(valorDeclarado);
    
              //let valorAjuste = d.ValorAjuste.toString().replace(/,/g, '');
              //valorAjusteAux = valorAjusteAux + Number(valorAjuste);
    
              let valorPrimaNeta = d.PrimaNeta.toString().replace(/,/g, '');
              valorPrimaNetaAux = valorPrimaNetaAux + Number(valorPrimaNeta);
    
              mesesDeclarados = mesesDeclarados + 1;
            }
    
          });
        }
    
        valorDeclaradoAux = Number(valorDeclaradoAux.toFixed(2));
        valorPrimaNetaAux = Number(valorPrimaNetaAux.toFixed(2));
        //    valorAjusteAux = Number(valorAjusteAux.toFixed(2));
    
        this.totalDeclarado = valorDeclaradoAux;
        this.totalPrimaNeta = valorPrimaNetaAux;
        this.totalAjuste = this.totalPrimaNeta;
    
    
        //cálculo de ajustes
        this.totalAnualDeclarado = valorDeclaradoAux;
        //this.promedioMensual = mesesDeclarados != 0 ? Number((valorAjusteAux / mesesDeclarados).toFixed(2)) : 0;
        //this.primaNetaAnualReal = Number((this.promedioMensual * (this.tasa / 100)).toFixed(2));
        this.primaNetaAnualReal = Number(this.totalPrimaNeta.toFixed(2));
        this.primaEnDeposito = mesesDeclarados != 0 ? Number(((this.totalAnualDeclarado / mesesDeclarados) * (this.mercaderia.Tasa / 100) * (this.modalidad / 100)).toFixed(2)) : 0;
        this.primaApagar = this.primaNetaAnualReal - this.primaEnDeposito;
    
/*         if (this.poliza.TipoTransaccion == 6 || this.poliza.Poliza.PrimaEnDeposito) { //sin prima
          this.priNet = 0;
          this.priTot = 0;
        } */
    
      }

      EncerarAjuste() {
        this.totalAnualDeclarado = 0;
        this.promedioMensual = 0;
        this.primaNetaAnualReal = 0;
        this.primaEnDeposito = 0;
        this.primaApagar = 0;
      }      

      getMyStyles(valorDeclarado: any, valorAjuste: any) {

        if (valorDeclarado == undefined || valorDeclarado == null)
          valorDeclarado = 0
    
        if (valorAjuste == undefined || valorAjuste == null)
          valorAjuste = 0
    
        let myStyles = {
          'color': Number(valorDeclarado.toString().replace(/,/g, '')) > Number(valorAjuste.toString().replace(/,/g, '')) ? 'red' : 'black',
          'text-align': 'right'          
        };
        return myStyles;
      }


      EnviarSolicitud()
      {
        this.showLoader = "sk-loading";
        let tieneTabla: boolean = false;
        
        let declaracionUsuario = new DeclaracionUsuario();
        declaracionUsuario.Poliza = new DeclaracionesEntity();
        declaracionUsuario.Declaraciones = new Declaracion();
        declaracionUsuario.Declaraciones.DetalleDeclaraciones = new Array<DetalleDeclaracion>();

        try {
            declaracionUsuario.Cliente = JSON.parse(this.sesionStorageService.retrieve("usuario"));
        } catch (e) {
            declaracionUsuario.Cliente = this.sesionStorageService.retrieve("usuario");
        }
        try {
            declaracionUsuario.ClienteSelect = JSON.parse(this.sesionStorageService.retrieve("usuarioempresa"));
        } catch (e) {
            declaracionUsuario.ClienteSelect = this.sesionStorageService.retrieve("usuarioempresa");
        }

        if(this.polizaSeleccionada.CodigoRamo == "0300")        
            declaracionUsuario.DireccionMercaderia = this.dirRubro.Direccion;        
        else        
            declaracionUsuario.DireccionMercaderia = this.mercaderia.DescripcionMercaderia;
        
          if (this.tablaDeclarativa != undefined && this.tablaDeclarativa != null && this.tablaDeclarativa.length > 0) {
              this.tablaDeclarativa.forEach(d => {
                  if (d.Seleccionado && d.Habilitado && d.ValorDeclarado != undefined && d.ValorDeclarado != null)
                      tieneTabla = true;
              });

              if (!tieneTabla)
                  this.tablaDeclarativa = new Array<DetalleDeclaracion>();
          }


        declaracionUsuario.Observaciones = this.observaciones;
        declaracionUsuario.Poliza = this.polizaSeleccionada;
        declaracionUsuario.Declaraciones.DetalleDeclaraciones = this.tablaDeclarativa;
        



        this.declaracionesService.EnviarSolicitudDeclaracion(declaracionUsuario).subscribe(result => {
            swal({
                title: 'Declaración de ' + this.polizaSeleccionada.NombreRamo, // + this.polizaSeleccionada.CodigoRamo === "0300" ? 'Incendio' : 'Transporte Interno',
                text: "La solicitud de declaración ha sido enviada con éxito.",
                type: 'success'
            }).then((function () {
                this.showLoader = "";
                window.location.reload();
            }).bind(this));
        }, error => { this.handleError.redirectUrl(error); });
        this.showLoader = "";
      }
      
      VerificarAjusteTransporte(codigoDetalle: number) {

        if (codigoDetalle == 0 || codigoDetalle == undefined) { //tabla sin grabar, aplica a todos los registros
    
          this.tablaDeclarativa.forEach(d => {
    
            if (d.Seleccionado && d.ValorDeclarado != null) {
              let valorDeclaradoAux = d.ValorDeclarado.toString().replace(/,/g, '');
              let valorDeclarado = Number(valorDeclaradoAux);
    
                d.PrimaNeta = Number((valorDeclarado * (this.mercaderia.Tasa / 100)).toFixed(2));
            
            }
    
          });
    
        }
        else {
          let registroCambiado: DetalleDeclaracion = new DetalleDeclaracion();
    
          this.tablaDeclarativa.filter(d => d.CodigoDetDeclaracion == codigoDetalle).forEach(t => {
            registroCambiado = t;
          });
    
          if (registroCambiado.ValorDeclarado != undefined) {
            let valorDeclaradoAux = registroCambiado.ValorDeclarado.toString().replace(/,/g, '');
            let valorDeclarado = Number(valorDeclaradoAux);
    
            registroCambiado.PrimaNeta = Number((valorDeclarado * (this.mercaderia.Tasa / 100)).toFixed(2));
          }
    
          this.tablaDeclarativa.forEach(d => {
            if (d.CodigoDetDeclaracion == codigoDetalle)
              d.PrimaNeta = registroCambiado.PrimaNeta;
          });
        }
    
        this.TotalizaValores();
        //this.CalcularPrimas();
    
      }



}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/declaraciones/declaraciones.component.ts